export enum OnyxMapLayerType {
  DEFAULT = 'default',
  SATELLITE = 'satellite',
  TRAFFIC = 'traffic',
  RESTRICTIONS = 'restrictions',
}
